import { InnerWrapper } from '../styles';
import NavigationSteps from '../navigation-steps';
import type { StepHeaderNavigationProps } from '../types';

const DesktopNavigation = ({ handleGoToStep }: StepHeaderNavigationProps) => (
  <InnerWrapper>
    <NavigationSteps handleGoToStep={handleGoToStep} />
  </InnerWrapper>
);

export default DesktopNavigation;
